// extracted by css-extract-rspack-plugin
export default {"infoRow":"infoRow-uDefO3","tooltip":"tooltip-B5Tn2B","infoButton":"infoButton-hBdwiy"};